
<script>

import Axios from 'axios'
    import config from '../../libs/config.js';
    import api from '../../api'
    import { mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'
    import _system from '../../libs/system'	


  import { supabase } from "../../libs/supabaseClient";

  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';

export default {
   name: "trackingCode",
   data() {
      return {
         currentPage: {},
         config: { },
         widgetConfig: {
        widgetHeader: {
          backgroundColor: "#F6F6F6",
           widgetName: {
            color:"#202325",
            name: 'Davin',
           },
           widgetClose:{
            size: "46px",
            Color: "rgba(0, 0, 0, 0.7)",
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            fontSize: ""
           }
        },
        messageContainer: {
          color: "#ffffff",
          botBubble: {
            fontColor: "#303437",
            backgroundColor: "#f2f4f5",
            Text: 'Hello! 👋 I am your personal shopping assistant! How can I help you today? ',
          },
          agentBubble: {
            fontColor: "#ffffff",
            backgroundColor: "#0070f0"
          }
        },
        widgetFooter: {
          backgroundColor: "#F6F6F6",
          footerInput: {
            fontColor: "#303437"
          },
          footerSubmit: {
            backgroundColor: "#444444",
            iconColor: "#ffffff",
          }
        }

      }
      }
   },
   computed: {
   ...mapGetters('session', ['isLoggedIn', 'getUser', 'getWhiteLabel']),
   ...mapGetters("workspaces", ["workspaces", "currentWorkspace", "workspacesByUser"]),
   ...mapGetters('contacts', ['contacts']),
   ...mapGetters('accounts', ['accounts']),
    ...mapGetters('networks', ['networks','networksByName']),
   },
   methods: {
   ...mapActions("session", ["setUser"]),
   ...mapActions("contacts", ["setContacts"]),
   ...mapActions("htmlModals", ["setEditUser"]),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
   enable(){
      alert('At present, this feature is undergoing a private beta phase. Access to this feature will be extended to all users in the near future.')
   },
   resetConfig(){
    this.config.botName = 'Davin',
    this.config.botText = 'Hello! 👋 I am your personal shopping assistant! How can I help you today? '
    this.config.headerColor = this.widgetConfig.widgetHeader.backgroundColor
    this.config.botNameColor = this.widgetConfig.widgetHeader.widgetName.color
    this.config.botBubbleColor = this.widgetConfig.messageContainer.botBubble.backgroundColor
    this.config.botTextColor  = this.widgetConfig.messageContainer.botBubble.fontColor
    this.config.customerBubbleColor = this.widgetConfig.messageContainer.agentBubble.backgroundColor
    this.config.customerTextColor = this.widgetConfig.messageContainer.agentBubble.fontColor
    this.config.containerColor = this.widgetConfig.messageContainer.color
    this.config.footerColor = this.widgetConfig.widgetFooter.backgroundColor
    this.config.footerSubmitColor = this.widgetConfig.widgetFooter.footerSubmit.backgroundColor
    this.config.footerSubmitIconColor = this.widgetConfig.widgetFooter.footerSubmit.iconColor

    let payload = {
      query: {
        pageId: this.currentPage._id
      },
      body: this.config
    }

    _system.services.accounts.updateConfig(payload, (err, updatedPage) => {
        if(err) return iziToast.error({ position: 'bottomCenter', title: `${err.data.message}`, });
    });   

    this.applyConfig()

    iziToast.info({
     position: 'bottomCenter',
     message: 'Your settings have been reset.',
     color: 'grey'
  });
   },
   saveConfig(){

    let payload = {
      query: {
        pageId: this.currentPage._id
      },
      body: this.config
    }

    _system.services.accounts.updateConfig(payload, (err, updatedPage) => {
        if(err) return iziToast.error({ position: 'bottomCenter', title: `${err.data.message}`, });

        iziToast.success({ position: 'bottomCenter', title: 'Updated Your Settings', });

    });               

   },
   getConfig(){
    let query = {
        pageId: this.currentPage._id
    }

    _system.services.accounts.getConfig(query, (err, configData) => {
        if(err) return alert(err.data.message);
       if(configData.widgetConf){
        this.config = configData.widgetConf
       }else{
        this.config = {
             headerColor: this.widgetConfig.widgetHeader.backgroundColor,
             botBubbleColor: this.widgetConfig.messageContainer.botBubble.backgroundColor,
             botTextColor: this.widgetConfig.messageContainer.botBubble.fontColor,
             customerBubbleColor: this.widgetConfig.messageContainer.agentBubble.backgroundColor,
             customerTextColor: this.widgetConfig.messageContainer.agentBubble.fontColor,
             containerColor: this.widgetConfig.messageContainer.color,
             footerColor: this.widgetConfig.widgetFooter.backgroundColor,
             footerSubmitColor: this.widgetConfig.widgetFooter.footerSubmit.backgroundColor,
             footerSubmitIconColor: this.widgetConfig.widgetFooter.footerSubmit.iconColor,
             botNameColor: this.widgetConfig.widgetHeader.widgetName.color
         };
       }
    

        this.applyConfig()

    });   
   },
   applyConfig() {
    document.documentElement.style.setProperty('--juphy-chatbot-header-color', this.config.headerColor);
    document.documentElement.style.setProperty('--juphy-chatbot-bot-bubble-color', this.config.botBubbleColor);
    document.documentElement.style.setProperty('--juphy-chatbot-bot-text-color', this.config.botTextColor);
    document.documentElement.style.setProperty('--juphy-chatbot-agent-bubble-color', this.config.customerBubbleColor);
    document.documentElement.style.setProperty('--juphy-chatbot-agent-text-color', this.config.customerTextColor);
    document.documentElement.style.setProperty('--juphy-chatbot-container-color', this.config.containerColor);
    document.documentElement.style.setProperty('--juphy-chatbot-footer-color', this.config.footerColor);
    document.documentElement.style.setProperty('--juphy-chatbot-footer-submit-color', this.config.footerSubmitColor);
    document.documentElement.style.setProperty('--juphy-chatbot-footer-submit-icon-color', this.config.footerSubmitIconColor);
    document.documentElement.style.setProperty('--juphy-chatbot-bot-name-color', this.config.botNameColor);
  }    
   },
   mounted(){
 $('.ui.accordion')
  .accordion()
;
$('.ui.accordion').accordion('toggle', 0);
    var headerColor = document.querySelector('#headerColor');
    var botBubbleColor = document.querySelector('#botBubbleColor')
    var botTextColor = document.querySelector('#botTextColor')
    var botNameColor = document.querySelector('#botNameColor')
    var customerBubbleColor = document.querySelector('#customerBubbleColor')
    var customerTextColor = document.querySelector('#customerTextColor')
    var footerColor = document.querySelector('#footerColor')
    var footerSubmitColor = document.querySelector('#footerSubmitColor')
    var footerSubmitIconColor = document.querySelector('#footerSubmitIconColor')
    var containerColor = document.querySelector('#containerColor')

var headerPicker = new window.Picker({
  parent: headerColor,
  color: this.widgetConfig.widgetHeader.backgroundColor,
  popup: 'top',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  headerPicker.onChange = (color) => {
      this.config.headerColor = color.hex
      
      this.applyConfig()
  };

var botBubblePicker = new window.Picker({
  parent: botBubbleColor,
  color: this.widgetConfig.messageContainer.botBubble.backgroundColor,
  popup: 'top',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  botBubblePicker.onChange = (color) => {
      this.config.botBubbleColor = color.hex

      this.applyConfig()
  };

var botTextPicker = new window.Picker({
  parent: botTextColor,
  color: this.widgetConfig.messageContainer.botBubble.fontColor,
  popup: 'top',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  botTextPicker.onChange = (color) => {
      this.config.botTextColor = color.hex

      this.applyConfig()
  };

var botNamePicker = new window.Picker({
  parent: botNameColor,
  color: this.widgetConfig.widgetHeader.widgetName.color,
  popup: 'top',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  botNamePicker.onChange = (color) => {
      this.config.botNameColor = color.hex

      this.applyConfig()
  };

  var customerBubbleColorPicker = new window.Picker({
  parent: customerBubbleColor,
  color: this.widgetConfig.messageContainer.agentBubble.backgroundColor,
  popup: 'top',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  customerBubbleColorPicker.onChange = (color) => {
      this.config.customerBubbleColor = color.hex

      this.applyConfig()
  };

  var containerColorPicker = new window.Picker({
  parent: containerColor,
  color: this.widgetConfig.messageContainer.color,
  popup: 'top',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  containerColorPicker.onChange = (color) => {
      this.config.containerColor = color.hex

      this.applyConfig()
  };

  var customerTextPicker = new window.Picker({
  parent: customerTextColor,
  color: this.widgetConfig.messageContainer.agentBubble.fontColor,
  popup: 'top',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  customerTextPicker.onChange = (color) => {
      this.config.customerTextColor = color.hex

      this.applyConfig()
  };

  var footerColorPicker = new window.Picker({
  parent: footerColor,
  color: this.widgetConfig.widgetFooter.backgroundColor,
  popup: 'bottom',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  footerColorPicker.onChange = (color) => {
      this.config.footerColor = color.hex

      this.applyConfig()
  };

  var footerSubmitPicker = new window.Picker({
  parent: footerSubmitColor,
  color: this.widgetConfig.widgetFooter.footerSubmit.backgroundColor,
  popup: 'top',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  footerSubmitPicker.onChange = (color) => {
      this.config.footerSubmitColor = color.hex

      this.applyConfig()
  };
  var footerSubmitIconPicker = new window.Picker({
  parent: footerSubmitIconColor,
  color: this.widgetConfig.widgetFooter.footerSubmit.iconColor,
  popup: 'top',
  editorFormat: 'hex'
});

  // You can do what you want with the chosen color using two callbacks: onChange and onDone.
  footerSubmitIconPicker.onChange = (color) => {
      this.config.footerSubmitIconColor = color.hex

      this.applyConfig()
  };
      


   this.applyConfig()
   

   },
   created(){
    let shopifyAccount = _.find(this.accounts, { platform: this.networksByName['Shopify']._id });
    if(shopifyAccount){
      this.currentPage = shopifyAccount
      this.getConfig()
    }else{
      this.config.botName = 'Davin',
      this.config.botText = 'Hello! 👋 I am your personal shopping assistant! How can I help you today? '
      this.config.headerColor = this.widgetConfig.widgetHeader.backgroundColor
      this.config.botNameColor = this.widgetConfig.widgetHeader.widgetName.color
      this.config.botBubbleColor = this.widgetConfig.messageContainer.botBubble.backgroundColor
      this.config.botTextColor  = this.widgetConfig.messageContainer.botBubble.fontColor
      this.config.customerBubbleColor = this.widgetConfig.messageContainer.agentBubble.backgroundColor
      this.config.customerTextColor = this.widgetConfig.messageContainer.agentBubble.fontColor
      this.config.containerColor = this.widgetConfig.messageContainer.color
      this.config.footerColor = this.widgetConfig.widgetFooter.backgroundColor
      this.config.footerSubmitColor = this.widgetConfig.widgetFooter.footerSubmit.backgroundColor
      this.config.footerSubmitIconColor = this.widgetConfig.widgetFooter.footerSubmit.iconColor
    }
   }
}

</script>

<template>


<div class="ui stackable grid">
  <div style="background: #ffffff;" class="eight wide column">
   <div class="ui basic segment">
      <div class="ui fluid card">
        
      <div class="content">
         <div class="description">

            <h3>🌟 Customize Your Chatbot Experience! 🌟</h3>

<p>Welcome to our Chatbot Customization Page! We believe in providing you with a personalized and tailored experience. Take control of your interactions with our chatbot by customizing its configuration to suit your preferences.</p>
<!--             <h4>How does it work?</h4>
            <p>When you send a product link via Juphy on Instagram Direct message, our tracking code will automatically start tracking the user's actions on your website. This means that you'll be able to see whether the user made a purchase, added the product to their cart, or simply browsed your website.</p> -->
         
            <div class="ui styled fluid accordion" ref="customizationAccordion">
    <!-- Header Section -->
    <div class="title">
      <i class="dropdown icon"></i>
      Header
    </div>
    <div class="content">
      <form class="ui form">
        <div class="field">
          <label>Chatbot Name</label>
          <input v-model="config.botName" type="text" placeholder="Chatbot Name">
        </div>
        <div class="field">
          <label>Chatbot Name Color</label>
          <input v-model="config.botNameColor" type="text" placeholder="Hex Color" readonly>
          <div id="botNameColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.botNameColor}"></div>
          </div>
        </div>
        <div class="field">
          <label>Header Color</label>
          <input v-model="config.headerColor" type="text" placeholder="Hex Color" readonly>
          <div id="headerColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.headerColor}"></div>
          </div>
        </div>
      </form>
    </div>

    <!-- Message Body Section -->
    <div class="title">
      <i class="dropdown icon"></i>
      Message Body
    </div>
    <div class="content">
      <form class="ui form">
        <div class="field">
          <label>Bot Text</label>
          <input v-model="config.botText" type="text" placeholder="Bot Text">
        </div>
        <div class="field">
          <label>Bot Bubble Color</label>
          <input v-model="config.botBubbleColor" type="text" placeholder="Hex Color" readonly>
          <div id="botBubbleColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.botBubbleColor}"></div>
          </div>
        </div>
        <div class="field">
          <label>Bot Text Color</label>
          <input v-model="config.botTextColor" type="text" placeholder="Hex Color" readonly>
          <div id="botTextColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.botTextColor}"></div>
          </div>
        </div>
        <div class="field">
          <label>Customer Bubble Color</label>
          <input v-model="config.customerBubbleColor" type="text" placeholder="Hex Color" readonly>
          <div id="customerBubbleColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.customerBubbleColor}"></div>
          </div>
        </div>
        <div class="field">
          <label>Customer Text Color</label>
          <input v-model="config.customerTextColor" type="text" placeholder="Hex Color" readonly>
          <div id="customerTextColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.customerTextColor}"></div>
          </div>
        </div>
        <div class="field">
          <label>Message Container Color</label>
          <input v-model="config.containerColor" type="text" placeholder="Hex Color" readonly>
          <div id="containerColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.containerColor}"></div>
          </div>
        </div>
      </form>
    </div>

    <!-- Footer Section -->
    <div class="title">
      <i class="dropdown icon"></i>
      Footer
    </div>
    <div class="content">
      <form class="ui form">
        <div class="field">
          <label>Footer Color</label>
          <input v-model="config.footerColor" type="text" placeholder="Hex Color" readonly>
          <div id="footerColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.footerColor}"></div>
          </div>
        </div>
        <div class="field">
          <label>Footer Button Color</label>
          <input v-model="config.footerSubmitColor" type="text" placeholder="Hex Color" readonly>
          <div id="footerSubmitColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.footerSubmitColor}"></div>
          </div>
        </div>
        <div class="field">
          <label>Footer Button Color</label>
          <input v-model="config.footerSubmitIconColor" type="text" placeholder="Hex Color" readonly>
          <div id="footerSubmitIconColor">
            <div style="width: 100%; height: 40px; border-radius: 0.3rem; cursor: pointer; border: 1px solid #ccc;" :style="{'background': config.footerSubmitIconColor}"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
         </div>
      </div>
      <div class="extra content">
         <div class="ui button" :class="{ 'disabled': Object.keys(this.currentPage).length === 0 }" @click="resetConfig">Default</div>
         <div class="ui green button" :class="{ 'disabled': Object.keys(this.currentPage).length === 0 }" @click="saveConfig">Update</div>
      </div>
      </div>
    </div>
  </div>
  <div style="background: #ffffff; display: flex; justify-content: column;" class="eight wide column">
   <div class="ui basic segment">
      <h3 style="margin-top: 0.5rem;">Preview</h3>
      <div id="WebChatwidget" class="WebChatwidget">
        <div class="wcw_wrapper">
          <div class="wcw_header">
            <div class="content">
              <div class="agents">
                <img
                  src="https://www.svgrepo.com/show/382095/female-avatar-girl-face-woman-user-4.svg"
                  alt=""
                />
              </div>
              <div class="status">
                <div class="label" style="opacity: 0.9">
                  <div class="widgetName">{{ config.botName }}</div>
                </div>
                <div class="label">
                  <div><span class="indicator"></span></div>
                  <div class="widgetStatus">Always active</div>
                </div>
              </div>
            </div>
          </div>
          <div id="wcw_messages_container" class="wcw_messages_container">
            <ul id="wcw_messages">
              <li class="clearfix bot" data-aos="fade-right">
                <img
                  class="msgIcon"
                  src="https://www.svgrepo.com/show/382095/female-avatar-girl-face-woman-user-4.svg"
                  alt=""
                />
                <div class="content">
                  {{ config.botText }}
                </div>
              </li>
              <li class="clearfix" data-aos="fade-right">
                <div class="content agent">
                  How do i refund an item?
                </div>
              </li>
            </ul>
          </div>
          <form id="wcw_form" action="">
            <input
              id="wcw_input"
              onkeydown="checkEnter(event)"
              placeholder="Type a message..."
              autocomplete="off"
            /><button id="wcw_form_button">
              <svg
                fill="#FFFFFF"
                version="1.1"
                id="ic_send"
                onclick="sendMessage()"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 24.00 24.00"
                xml:space="preserve"
                width="44px" 
                height="44px"
                transform="matrix(1, 0, 0, 1, 0, 0)rotate(-45)"
                stroke="#FFFFFF"
                stroke-width="0.00024000000000000003"
              >
                <g
                  id="SVGRepo_bgCarrier"
                  stroke-width="0"
                  transform="translate(0,0), scale(1)"
                >
                  <rect
                    x="0"
                    y="0"
                    width="24.00"
                    height="24.00"
                    rx="12"
                    fill="#444444"
                    strokewidth="0"
                  ></rect>
                </g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke="#CCCCCC"
                  stroke-width="0.288"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g id="ic_send_icon">
                    <path d="M2,3v7.8L18,12L2,13.2V21l20-9L2,3z"></path>
                  </g>
                  <rect class="st0" width="24" height="24"></rect>
                </g>
              </svg>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>

</div>

   


</template>


<style scoped>

.ui.card, .ui.cards > .card {
   -webkit-box-shadow: none !important;
   box-shadow: none !important;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.front{
  box-shadow: rgb(224, 224, 224) 0px 2px 4px !important;
  border-radius: 5px !important;
  background: #ffffff !important;
}

.active{
   font-weight:bold !important;
}
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.65) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 2px 54px rgba(99, 99, 99, 0.85);
   border: none;
   background: #eee;
}

.WebChatwidget {
  overflow: auto;
  width: 70vw;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.7);
  right: 1rem;
  bottom: 1rem;
  border: 1px solid #CFCFCF;
}
.wcw_wrapper {
  display: flex;
  max-height: 100%;
  overflow: auto;
  flex-direction: column;
  position: relative;
}

.wcw_wrapper .wcw_header {
  height: 100%;
  border-radius: 10px 10px 0 0;
  background: #ffffff;
}

.wcw_wrapper .wcw_header .content {
  display: flex;
  position: relative;
  padding: 1rem;
  background-color: var(--juphy-chatbot-header-color);
}

.hidden {
  display: none !important;
}

.wcw_wrapper .wcw_header .agents {
  margin-right: 12px;
  width: 2.75rem;
  height: 2.75rem;
}

.wcw_wrapper .wcw_header .status {
  display: flex;
  flex-direction: column;
}

.wcw_wrapper .wcw_header .status .label {
  display: flex;
  border-radius: 50px;
  align-items: center;
  height: 20px;
  align-items: center;
}
.wcw_wrapper .wcw_header .status .label div {
  width: 8px;
  height: 8px;
  margin-right: 4px;
  top: 10px;
}

.wcw_wrapper .wcw_header .status .label .widgetName {
  color: var(--juphy-chatbot-bot-name-color);
  width: inherit;
  height: 1rem;
  font-family: Helvetica;
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.25rem;
}

.wcw_wrapper .wcw_header .status .label .widgetStatus {
  width: inherit;
  height: 1rem;
  color: #72777A;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 1rem;
}

.wcw_wrapper .wcw_header .status .label .indicator {
  height: 0.5rem;
  width: 0.5rem;
  background: #7DDE86;
  border-radius: 8px;
  display: block;
  margin-right: 5px;
}

.wcw_wrapper .wcw_header .content img {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  border: 2px solid #fff;
  right: 0;
}

.wcw_wrapper .wcw_header .content .wcw_close {
  position: absolute;
  width: 44px;
  height: 44px;
  transition: 0.5s;
  border-radius: 8px;
  margin-right: 34px;
  right: 0;
  border: 1px solid;
  border-color: #e3e5e5;
  border-radius: 2rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.wcw_wrapper .wcw_header .content .wcw_close .svg {
  display: inline-block;
  margin: 19%;
}

.wcw_wrapper .wcw_header .content:hover .wcw_close {
  opacity: 1;
}

.wcw_wrapper .wcw_header .content .wcw_close:hover {
  background: rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.wcw_wrapper .wcw_messages_container {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100vh;
  background-color: var(--juphy-chatbot-container-color)
}

.wcw_wrapper form {
  justify-content: space-between;
  width: inherit;
  padding: 1rem;
  background-color: var(--juphy-chatbot-footer-color);
  display: flex;
  margin: 0;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.wcw_wrapper form > input {
  position: sticky;
  bottom: 0;
  height: 2.75rem;
  width: 100%;
  padding: 10px 20px 10px 20px;
  margin: auto;
  flex-grow: 1;
  max-height: 100%;
  border-radius: 1rem;
  font-size: 1rem;
  border: 1.5px solid;
  border-color: #979C9E;
  box-sizing: border-box;
}

.wcw_wrapper form > input:focus {
  outline: none;
}

.wcw_wrapper form > button {
  background: transparent;
  border-style: none;
  cursor: pointer;
  width: fit-content;
  margin-left: 1rem;
  padding: 0%;
}

#wcw_form_button #ic_send {
  fill: #444444;
  width: 2.75rem;
  height: 2.75rem;
}
#ic_send_icon path {
  fill:var(--juphy-chatbot-footer-submit-icon-color);
  transform: scale(0.5633333333333334);
}
#wcw_form_button #ic_send #ic_send_icon {
  transform: translate(7px,5px);
}


.wcw_wrapper #wcw_messages {
  list-style-type: none;
  margin: 0;
  padding: 0 1rem 0 1rem;
  align-items: center;
}

.wcw_wrapper #wcw_messages > li {
  margin-bottom: 1rem;
  display: block;
}
.wcw_wrapper #wcw_messages > li.clearfix.bot {
  display: flex;
  width: fit-content;
  justify-content: flex-start;
}

.wcw_wrapper #wcw_messages > li:last-child {
  margin-bottom: 1rem;
  display: block;
}

.wcw_wrapper #wcw_messages > li:first-child {
  margin-top: 1rem;
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

.wcw_wrapper #wcw_messages > li > .content {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  line-height: 24px;
  padding: 1rem;
  background: var(--juphy-chatbot-bot-bubble-color);
  color: var(--juphy-chatbot-bot-text-color);
  border-radius: 0px 24px 24px 24px;
  word-wrap: break-word;
  width: fit-content;
  text-align: left;
}

.wcw_wrapper #wcw_messages > li > img {
  width: 2rem;
  height: 2rem;
  align-self: flex-start;
  margin-right: 10px;
}

.wcw_wrapper #wcw_messages > li > .content.agent {
  padding: 1rem;
  color: var(--juphy-chatbot-agent-text-color);
  background: var(--juphy-chatbot-agent-bubble-color);
  border-radius: 24px 24px 0px 24px;
  float: right;
  max-width: 75%;
}
.wcw_wrapper #wcw_messages > li > .content.email {
  padding: 1rem;
  background: white;
  border-radius: 1rem;
  float: right;
  max-width: 70%;
}

.link-preview {
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 0.5rem 0;
  padding: 0.5rem;
  border-radius: 8px;
  background-color: #f5f5f5;
}

.preview-image {
  max-height: 100%;
  height: 80px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 8px;
  margin-bottom: 2px;
}

.preview-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 0.5rem;
}

.preview-title {
  font-weight: bold;
  margin-bottom: 0.25rem;
  font-size: medium;
  color: rgba(0, 0, 0, 0.7)
}

.preview-description {
  color: rgba(0, 0, 0, 0.7);
  font-size: small;
}

.form-container {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: white;
  color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  width: fit-content;
  float: right;
}

.form-container input[type="email"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px 0px 0px 5px;
  width: 100%;
  outline: none;
}
.form-container input[type="email"]::placeholder {
  opacity: 0.3;
}

.form-container button {
  padding: 5px 20px;
  background-color: #4169e1;
  border: none;
  border-radius: 0px 5px 5px 0px;
  color: white;
  cursor: pointer;
  font-size: 1.5rem;
  position: relative;
  overflow: hidden;
}

.form-container button::before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  line-height: 1;
}

.get-notified-text {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.input-group {
  display: flex;
}

.st0 {
  fill: none;
}

.buttonGroup {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.optionsButton {
  background-color: #e5eeff;
  color: #003499;
  padding: 10px 20px;
  border-radius: 6px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  font-size: 14px;
  line-height: 18px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  white-space: nowrap;
}

.optionsButton:hover {
  color: #e5eeff;
  background-color: #003499;
  transition: all 0.5s;
}

.wcw_wrapper #wcw_messages > li > .content.richMsg {
  display: flex;
  flex-direction: column;
  border-radius: 0px 24px 24px 24px;
  line-height: 10px;
  background: #f2f4f5;
  padding: 1rem;
  position: relative;
}
/* Footer Button Color */
#SVGRepo_bgCarrier rect {
  fill: var(--juphy-chatbot-footer-submit-color);
}
.richMsgImg img {
  max-width: 100%;
  height: 8.125rem;
  border-radius: 10px;
  margin-top: 0.9rem;
  width: 100%;
}

.richMsgImg {
  margin-bottom: 10px;
}

.wcw_wrapper #wcw_messages>li>.content>.button{
  padding: 5px 7px; 
  color: #003499;
  border-radius: 0.5rem;
  margin: 5px;
  display: inline-block;
  font-size: 14px;
  cursor: pointer;
}

.wcw_wrapper #wcw_messages>li>.content>.button:hover{
    color: #e5eeff;
    background-color: #003499;
    transition: all 0.5s;
  }

.richMsgTitle {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  line-height: 24px;
  color: #303437;
  font-weight: bold;
}
.richMsgDesc {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #303437;
  display: block;
}
.wcw_init {
  overflow: visible;
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  box-shadow: rgba(0, 18, 46, 0.16) 0px 8px 22px 0px;
  border-radius: 8px;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.7);
}

.wcw_init .wcw_classic {
  padding: 8px 12px;
  cursor: pointer;
}


.richMsgButton > .button2 {
  border-radius: 24px;
  width: 100%;
  margin-right: 1rem;
  cursor: pointer;
  padding: 8px 14px 8px 14px;
  border: 1px solid #C5D8FF;
  background-color: rgba(210, 228, 254, 0.29);
  color: rgba(58, 86, 140, 0.9);
  font-size: 0.875rem;
  line-height: 1.5rem;
}

/* Small to Medium screens */
@media screen and (min-width: 768px) and (max-width: 1000px) {
  .WebChatwidget {
    max-height: 100%;
    height: 80vh;
    width: 80vh;
    border-radius: 16px;
  }
}

/* Medium screens with a specific aspect ratio (e.g., 4:5) */
@media screen and (min-width: 768px) and (max-width: 1000px) and (max-aspect-ratio: 4/5) {
  .WebChatwidget {
    height: 60vh;
    width: 47vw;
  }
}

/* Large screens */
@media screen and (min-width: 1001px) and (min-height: 1000px) {
  .WebChatwidget {
    height: 60vh;
    width: 35vw;
  }
}

/* Extra Large screens */
@media screen and (min-width: 1001px) {
  .WebChatwidget {
    height: 70vh;
    width: 28vw;
  }
}

/* Large screens with specific height */
@media screen and (min-width: 900px) and (max-height: 900px) {
  .WebChatwidget {
    height: 85vh; 
    width: 27vw; 
  }
}

@media screen and (min-width: 1024px) and (min-height: 1366px) {
  .WebChatwidget {
    height: 60vh;
    width: 32vh;
  }
}

@media screen and (min-width: 1920px) and (min-height: 1080px) {
  .WebChatwidget {
    height: 60vh;
    width: 35vh;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/dashboard/Chatconfig.vue